import type { SportUiConfiguration } from "../../types/sportUiConfiguration.ts";
import { defaultsUiConfig } from "./defaultsUi.ts";

export const handballUiConfig: SportUiConfiguration = {
  ...defaultsUiConfig,
};
